import React, {useCallback} from 'react';
import CardAd from './cardAd';
import InfinitScroll from 'components/infinitScroll';
import useGetMyWanted from './hooks/useGetMyWanted';
import EmptyPost from 'assets/images/emptyPage/empty page.svg';
interface WantedProps {
  app: 'farm' | 'wholesaler';
  type: 'wanted-post';
}
const WantedAd = ({app, type}: WantedProps) => {
  const {MyWanteds, isLoading, fetchNextPage, refetch} = useGetMyWanted({
    profile_type: app === 'farm' ? 'farmer' : 'market',
  });

  const MyWantedsData = MyWanteds?.pages.flatMap(x => x.results) || [];
  const onWatchEnd = useCallback(() => {
    fetchNextPage();
  }, [fetchNextPage]);

  return (
    <div className="py-2 flex flex-wrap overflow-y-auto  justify-center w-full gap-4">
      <InfinitScroll isloading={isLoading} onWatchEnd={onWatchEnd}>
        {MyWantedsData.length === 0 ? (
          <div className=" mt-28">
            <img src={EmptyPost} alt="empty" className=" block mx-auto" />
            <p className=" text-gray-5 text-center">
              موردی برای نمایش وجود ندارد.
            </p>
          </div>
        ) : (
          MyWantedsData.map(item => (
            <div key={item.guid} className="flex  w-full justify-center">
              <CardAd
                item={item}
                type={type}
                app={app}
                status={item.status}
                wrapperClassName="!w-[320px]"
                refetch={refetch}
              />
            </div>
          ))
        )}
      </InfinitScroll>
    </div>
  );
};

export default WantedAd;
